import { routes } from "@app/routing";
import { IDP_TYPE } from "@app/service/user";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";

type QueryParams = Record<string, string>;

interface RedirectOptions {
  params?: QueryParams;
  preserveQuery?: boolean; // To preserve the query parameter from URL. By default true
}

export const usePortalRedirects = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const baseQueryParams = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const result: QueryParams = {};

    params.forEach((value, key) => {
      result[key] = value;
    });

    return result;
  }, [location.search]);

  const buildRedirect = (
    pathname: string,
    { params = {}, preserveQuery = true }: RedirectOptions = {}
  ) => {
    const mergedParams = preserveQuery
      ? { ...baseQueryParams, ...params }
      : { ...params };

    const searchParams = new URLSearchParams(mergedParams);
    navigate({ pathname, search: searchParams.toString() });
  };

  return {
    toLogin: (opts?: RedirectOptions) => buildRedirect(routes.logIn, opts),
    toSignUp: (opts?: RedirectOptions) => buildRedirect(routes.signUp, opts),
    toLoginRedirect: (opts?: RedirectOptions) =>
      buildRedirect(routes.loginRedirect, opts),
    toHome: (opts?: RedirectOptions) => buildRedirect(routes.home, opts),
    toActivation: (opts?: RedirectOptions) =>
      buildRedirect(routes.activation, opts),
    toBack: () => navigate(-1),
  };
};
